<template>
    <card class="form-horizontal">
        <div class="card-header">
        </div>
        <div class="card-body text-center">
            <h6 class="card-title text-center white">
                Refrescar EMI
            </h6>
            <div class="row">
                <div class="alert alert-info">
                    <span>La funcionalidad de Refrescar EMI descargará e instalará en su dispositivo la última versión disponible de EMI. Es necesario contar con conexión a internet</span>
                </div>
                <!-- <p-button @click="toReload()" type="block btn-warning">Refrescar EMI</p-button> -->
                 <p-button @click="forceUpdate" type="block btn-warning">Refrescar EMI</p-button>
            </div>
            <hr>
            <h6 class="card-title text-center white">
                Eliminar todos los datos
            </h6>
            <div class="row">
                <div class="alert alert-info">
                    <span>La funcionalidad de Eliminar todos los datos,  borrará de su dispositivo todos los archivos y evaluaciones de EMI. Es necesario contar con conexión a internet</span>
                </div>
                <!-- <p-button @click="toClear()" type="block btn-warning">Eliminar todos los datos</p-button> -->
                <p-button @click="clearBrowserDataAndReload" type="block btn-warning">Eliminar todos los datos</p-button>
            </div>
        </div>
        <div class="card-footer">
        </div>
    </card>
</template>
    <script>
    import swal from 'sweetalert2'
    import SecureLS from 'secure-ls';
    import { Card } from 'src/components/UIComponents'
    import axios from 'axios'
    export default {
        components: {
            Card
        },
        data() {
        return {
            
        }
        },
        computed: {
            loadingReviewComputed () {
                if (this.$apollo.queries.productTypes.loading || this.$apollo.queries.activityTypes.loading || this.$apollo.queries.creditTypes.loading || this.$apollo.queries.creditPurposes.loading) {
                    return true
                }
                else {
                    return false
                }
            }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showNotificationInfo (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'info'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            async forceUpdate() {
                if ('serviceWorker' in navigator) {
                    try {
                    const registration = await navigator.serviceWorker.getRegistration();
                    if (registration) {
                        this.showNotificationInfo("Forzando actualización del Service Worker...");
                        
                        // Forzar al Service Worker que actualice
                        await registration.update();

                        // Si hay un SW en estado "waiting", forzamos su activación
                        if (registration.waiting) {
                        registration.waiting.postMessage({ type: 'skipWaiting' });
                        
                        // Escuchar cuando el nuevo SW toma el control
                        navigator.serviceWorker.addEventListener('controllerchange', () => {
                            this.showNotificationSuccess("Nuevo Service Worker activado. Recargando...");
                            window.location.reload();
                        });
                        } else {
                        this.showNotificationInfo("El Service Worker ya está actualizado.");
                        }
                    } else {
                        this.showNotificationError("No se encontró un Service Worker registrado.");
                    }
                    } catch (error) {
                    this.showNotificationError("Error al intentar forzar la actualización del Service Worker:", error);
                    }
                } else {
                    this.showNotificationError("El navegador no soporta Service Workers.");
                }
            },
            /**
             * Limpia todas las cachés, localStorage, y sessionStorage,
             * y fuerza la recarga de la página con el contenido más reciente.
             */
            async clearBrowserDataAndReload() {
                try {
                    console.log("Limpiando cachés del navegador...");
                    // Eliminar todas las cachés
                    const cacheNames = await caches.keys();
                    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));

                    console.log("Cachés eliminadas. Limpiando localStorage y sessionStorage...");
                    // Limpiar localStorage y sessionStorage
                    localStorage.clear();
                    sessionStorage.clear();

                    console.log("Almacenamientos locales limpiados. Eliminando IndexedDB...");
                    // Eliminar bases de datos IndexedDB (opcional)
                    if (window.indexedDB) {
                    const databases = await indexedDB.databases();
                    await Promise.all(databases.map((db) => indexedDB.deleteDatabase(db.name)));
                    }

                    console.log("Datos del navegador eliminados. Recargando página...");
                    // Recargar la página
                    window.location.reload();
                } catch (error) {
                    console.error("Error al limpiar datos del navegador:", error);
                }
            },
            toReload() {
                // this.$router.push('/admin/pending_evaluations');
                window.location.replace("/reload/");
            },
            toClear() {
                // this.$router.push('/admin/finished_evaluations');
                window.location.replace("/clear/");
            },
        },
        mounted() {
            this.$store.dispatch('finishEvaluation', 'home').then(()=>{
                
            });
            // Con la siguiente función evitamos que el usuario pueda retroceder en el historial del navegador
            history.pushState(null, null, location.href);
            window.onpopstate = function () {
                history.go(1);
            };
            const url = process.env.VUE_APP_BACKEND_URL +'/api/gencookie';
            fetch(url)
            .then(data => data)
            .then(res => {
                // el resultado no importa, solo importa la cookie
                
            })
            .catch(error => { 
                console.info("Ocurrió un error al obtener la cookie!");
            });
            // this.startRequest();
        }
    }
</script>
<style>
.white {
    color: white;
}

</style>
